import '../../assets/css/styleLogin.css';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../context/user/UserContext';
import { IUser } from '../../types';
import { LoginService } from '../../services/auth';
import { ToastErro } from '../../components/toast';

const LoginPage = () => {

    const [loading, setLoading] = useState<boolean>(false);

    const navigate = useNavigate();

    const { setUser, setRoles } = useContext(UserContext);

    const { register, handleSubmit, formState: { errors } } = useForm<IUser>({
        defaultValues: {
            username: '',
            password: ''
        }
    });

    // função para fazer login
    const login = async (data: IUser) => {

        setLoading(true);

        await LoginService(data).then(resp => {

            // salvar o token no storage
            localStorage.setItem("token", resp.data.access_token);
            // salvar o token no storage

            // setar o usuário no contexto
            setUser(resp.data.user);
            setRoles(resp.data.roles);
            // setar o usuário no contexto            

            if (resp.data.roles.includes(1)) {
                navigate('/users');
            } else if(resp.data.roles.includes(2)) {
                navigate('/managers/dashboard');
            }else if(resp.data.roles.includes(3)) {
                navigate('/financial/dashboard');
            }else if(resp.data.roles.includes(4)) {
                navigate('/approvers/dashboard');
            }

        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);
    }
    // função para fazer login

    return (
        <div className="loginScreen">
            <div className="box">
                <form onSubmit={handleSubmit(login)}>
                    <h2>RDI</h2>
                    <div className="inputBox">
                        <input
                            type="text"
                            {...register('username')}
                            name="username"
                            autoComplete='off'
                            required
                        />
                        <span>Username</span>
                        <i></i>
                    </div>
                    <div className="inputBox">
                        <input
                            type="password"
                            {...register('password')}
                            name="password"
                            required
                        />
                        <span>Senha</span>
                        <i></i>
                    </div>
                    {
                        loading

                            ?

                            <div className="spinner-border text-light mt-5" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>

                            :

                            <button type='submit'>ENTRAR</button>
                    }
                </form>
            </div>
        </div>
    )

}

export default LoginPage;
